import { LoginStore } from "./LoginStore"
import { PopStore } from "./PopStore";
import { CoinStore } from "./CoinStore";
import { UserProfileStore } from "./UserProfileStore";
import { MiningStore } from "./MiningStore";
import { MissionStore } from "./MissionStore";
import { SaleStore } from "./SaleStore";
import { CoinExchangeStore } from "./CoinExchangeStore";


export class RootStore {
    loginStore;
    popStore;
    CoinStore;
    UserProfileStore;
    MiningStore;
    MissionStore;
    SaleStore;
    CoinExchangeStore;
    constructor() {
        this.loginStore = new LoginStore(this);
        this.popStore = new PopStore(this);
        this.CoinStore = new CoinStore(this);
        this.UserProfileStore = new UserProfileStore(this);
        this.MiningStore = new MiningStore(this);
        this.MissionStore = new MissionStore(this);
        this.SaleStore = new SaleStore(this);
        this.CoinExchangeStore = new CoinExchangeStore(this);

    }
}